import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';

const Terms = () => {
  return (
    <div data-testid="terms-page" className="min-h-screen pt-32 pb-24 px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-8"
        >
          <ChevronLeft className="h-4 w-4" />
          Tornar a l'inici
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-foreground mb-8">
            Termes i Condicions
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground mb-8">
              Última actualització: {new Date().toLocaleDateString('ca-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">1. Informació General</h2>
              <p className="text-foreground/80 mb-4">
                Aquestes condicions generals regulen l'ús del lloc web estelregals.com (d'ara endavant, "el lloc web"), propietat de:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li><strong>Titular:</strong> Teresa Porredon Solé</li>
                <li><strong>NIF:</strong> 38531828C</li>
                <li><strong>Adreça:</strong> Carrer Capità Arenas, 25, Baixos, 08034 Barcelona</li>
                <li><strong>Telèfon:</strong> 932 040 216</li>
                <li><strong>Activitat:</strong> Comerç de regals, parament de la casa i bijuteria</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">2. Objecte</h2>
              <p className="text-foreground/80 mb-4">
                El present lloc web té per objecte facilitar als usuaris la informació sobre els productes i serveis que ofereix Estel Regals, així com permetre la compra en línia dels mateixos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">3. Condicions d'Ús</h2>
              <p className="text-foreground/80 mb-4">
                L'accés i ús del lloc web atribueix la condició d'usuari i implica l'acceptació plena i sense reserves de totes i cadascuna de les disposicions incloses en aquests Termes i Condicions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">4. Productes i Preus</h2>
              <p className="text-foreground/80 mb-4">
                Tots els preus indicats al lloc web inclouen l'IVA i estan expresats en euros (€). Estel Regals es reserva el dret de modificar els preus dels productes sense previ avís, encara que els preus aplicables seran sempre els vigents en el moment de formalitzar la comanda.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">5. Procés de Compra i Pagament</h2>
              <p className="text-foreground/80 mb-4">
                El pagament de les comandes es realitza mitjançant passarel·la de pagament segur Stripe. Acceptem targetes de crèdit i dèbit. La comanda no es processarà fins que el pagament sigui confirmat.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">6. Recollida de Comandes</h2>
              <p className="text-foreground/80 mb-4">
                Les comandes es poden recollir a la botiga física situada al Carrer Capità Arenas, 25, Baixos, 08034 Barcelona. Un cop confirmada la comanda, rebreu un correu electrònic amb la confirmació i instruccions per a la recollida.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">7. Dret de Desistiment</h2>
              <p className="text-foreground/80 mb-4">
                Conforme a la legislació vigent, el client disposa d'un termini de 14 dies naturals, comptats des de la recepció del producte, per exercir el dret de desistiment sense necessitat de justificació. Els productes han de ser retornats en les mateixes condicions en què es van rebre.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">8. Garanties</h2>
              <p className="text-foreground/80 mb-4">
                Tots els productes disposen de la garantia legal de conformitat de 2 anys segons la normativa vigent. Aquesta garantia cobreix els defectes de fabricació i de conformitat dels productes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">9. Propietat Intel·lectual</h2>
              <p className="text-foreground/80 mb-4">
                Tots els continguts del lloc web, incloent-hi textos, fotografies, dissenys gràfics, icones i codi, són propietat de Estel Regals o tenen llicència d'ús i estan protegits per les lleis de propietat intel·lectual.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">10. Responsabilitat</h2>
              <p className="text-foreground/80 mb-4">
                Estel Regals no es fa responsable dels danys i perjudicis que puguin derivar-se de la utilització del lloc web, ni de la falta de disponibilitat o continuïtat del mateix.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">11. Legislació Aplicable i Jurisdicció</h2>
              <p className="text-foreground/80 mb-4">
                Aquests Termes i Condicions es regeixen per la legislació espanyola. Per a la resolució de qualsevol controvèrsia derivada de l'aplicació o interpretació d'aquests termes, les parts se sotmeten expressament als jutjats i tribunals de Barcelona.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">12. Contacte</h2>
              <p className="text-foreground/80 mb-4">
                Per a qualsevol consulta relacionada amb aquests Termes i Condicions, pot contactar-nos a:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Telèfon: 932 040 216</li>
                <li>Adreça: Carrer Capità Arenas, 25, Baixos, 08034 Barcelona</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;